import { IContact, Order } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum OneClickReceivingPeopleActionTypes {
  LOAD_RECEIVING_PEOPLE = '[One Click] Load receiving_people',
  LOAD_RECEIVING_PEOPLE_COMPLETE = '[One Click] Load receiving_people completed',
  SELECT_RECEIVING_PERSON = '[One Click] Select receiving_people',
  RESET = '[One Click] receiving_people reset',
  LOAD_RECEIVING_PEOPLE_ERROR = '[One Click] Load receiving_people error',
}

export class OneClickLoadReceivingPeopleAction implements Action {
  readonly type = OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE;

  constructor(public payload: Order) {}
}

export class OneClickLoadReceivingPeopleCompleteAction implements Action {
  readonly type = OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE_COMPLETE;

  constructor(public payload: IContact[]) {}
}

export class OneClickSelectReceivingPeopleAction implements Action {
  readonly type = OneClickReceivingPeopleActionTypes.SELECT_RECEIVING_PERSON;

  constructor(public payload: IContact) {}
}

export class OneClickResetReceivingPeopleAction implements Action {
  readonly type = OneClickReceivingPeopleActionTypes.RESET;

  constructor() {}
}

export class OneClickLoadReceivingPeopleErrorAction implements Action {
  readonly type = OneClickReceivingPeopleActionTypes.LOAD_RECEIVING_PEOPLE_ERROR;

  constructor(public payload: any) {}
}

export type OneClickReceivingPersonsActions =
  | OneClickLoadReceivingPeopleAction
  | OneClickLoadReceivingPeopleCompleteAction
  | OneClickSelectReceivingPeopleAction
  | OneClickResetReceivingPeopleAction
  | OneClickLoadReceivingPeopleErrorAction;
